/**
 * URL-safety helper — identical logic to ui/worker/src/url.ts,
 * deliberately duplicated (see that file's docstring) since the
 * frontend must independently distrust any URL it renders, even one
 * that already passed through the Worker: defense in depth, not
 * "the Worker already checked this."
 */

const ALLOWED_SCHEMES = new Set(["http:", "https:"]);

/** True only for http(s) URLs — never javascript:, data:, vbscript:, file:, or a malformed value. */
export function isSafeExternalUrl(value: string | null | undefined): boolean {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return ALLOWED_SCHEMES.has(parsed.protocol);
  } catch {
    return false;
  }
}
